import sortBy from "lodash/sortBy";
import { getFormattedCurrency } from "../../utils";
import { BulkMeetingPriceMapArgsType } from "./type";

export default function BulkQuantityPriceBreakUpMap(props: BulkMeetingPriceMapArgsType) {
  return (
    <div className={`bulkTicketPricing ${props.className ? props.className : ""}`}>
      {props.labelDisplayText && <span className="bulkTicketPricing--label">{props.labelDisplayText}</span>}
      {props.infoLabel && <span className="bulkTicketPricing--labelInfo">{props.infoLabel}</span>}
      <ul className="bulkTicketPricing_list">
        {sortBy(props.applicableRates, "lowerLimit").map((r, index) => (
          <li key={index} className="bulkTicketPricing_cardWrapper">
            <div className="bulkTicketPricing_card">
              <div className="bulkTicketPricing_cardHeader">
                <span className="bulkTicketPricing_cardHeader--limit">
                  {r.lowerLimit} - {r.upperLimit}
                </span>
              </div>
              <div className="bulkTicketPricing_cardFooter">
                <h4 className="bulkTicketPricing_cardFooter--heading">{getFormattedCurrency(r.applicablePrice)}</h4>
                <span className="bulkTicketPricing_cardFooter--displayText">{props.perQuantityDisplayText}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
